var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "minus.a08f661c.png","uri@2x": __webpack_public_path__ + "minus.03dba5fb.png","uri@3x": __webpack_public_path__ + "minus.c903fabe.png",
    width: 16,
    height: 2
});